import { useTranslation } from "react-i18next";
import { AlarmClock, CheckCircle2, CircleDot, Hourglass, ListTodo, Loader2 } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

// 6 بطاقات 3D Neu قابلة للنقر كفلاتر سريعة على الحالة.
const CARDS = [
  { key: "total", status: "", tone: "indigo", icon: ListTodo },
  { key: "new", status: "new", tone: "sky", icon: CircleDot },
  { key: "in_progress", status: "in_progress", tone: "amber", icon: Loader2 },
  { key: "pending_review", status: "pending_review", tone: "violet", icon: Hourglass },
  { key: "completed", status: "completed", tone: "emerald", icon: CheckCircle2 },
  { key: "overdue", status: "overdue", tone: "rose", icon: AlarmClock },
];

export const TaskStats = ({ stats, active, onPick, ready }) => {
  const { t } = useTranslation();
  if (!ready) {
    return (
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6" data-testid="task-stats-loading">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-28 animate-pulse rounded-3xl bg-muted/50 shadow-neu-sm" />
        ))}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6" data-testid="task-stats">
      {CARDS.map((c) => (
        <StatCard key={c.key} testId={`task-stat-${c.key}`} tone={c.tone} icon={c.icon}
                  label={t(`tasks.stats.${c.key}`)} value={stats[c.key] ?? 0}
                  active={active === c.status && c.status !== ""} onClick={() => onPick(c.status)} />
      ))}
    </div>
  );
};
